/**
 * A full-page error message to show when the user fails to load some data.
 */
import {t} from "@lingui/core/macro";

import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingLarge} from "@khanacademy/wonder-blocks-typography";
import {ErrorMessageWrapper} from "@khan/component-error-message";

import ReportError from "./report-error.tsx";

export default function ErrorLoading() {
    return (
        <ErrorMessageWrapper fillScreen={true}>
            <HeadingLarge style={{textAlign: "center"}}>
                {t`Oops. Something went wrong. Please try again.`}
            </HeadingLarge>
            <Body
                style={{
                    textAlign: "center",
                    marginBlockStart: spacing.xLarge_32,
                }}
            >
                <ReportError />
            </Body>
        </ErrorMessageWrapper>
    );
}
